import { PATH_ADMIN, PATH_DASHBOARD } from "routes/Paths";

export const NavbarLinks = [
  {
    id: "user",
    menuitem: "Dashboard",
    link: PATH_DASHBOARD.student.root,
    roles: ['user'],
  },
  {
    id: "instructor",
    menuitem: "Dashboard",
    link: PATH_DASHBOARD.instructor.root,
    roles: ['instructor'],
  },
  {
    id: "administrator",
    menuitem: "Admin",
    link: PATH_ADMIN.admin.courses,
    roles: ['administrator', 'reviewer'],
  },
];

const LINKS = [NavbarLinks];

export default LINKS;
